// extracted by mini-css-extract-plugin
export default {"guide":"hONnWqTvPDcqLLIiZaWz"};